import * as O from 'fp-ts/lib/Option';
import qs from 'query-string';
import {pipe} from 'fp-ts/lib/pipeable';

export const safeParseInt = (value: string) =>
  pipe(
    O.some(parseInt(value, 10)),
    O.chain(parsedInt => (isNaN(parsedInt) ? O.none : O.some(parsedInt)))
  );

export const safeParseJson = <T>() => (value: string): O.Option<T> =>
  pipe(
    O.tryCatch(() => JSON.parse(value)),
    O.chain(O.fromNullable)
  );

export const safeParseJSONAsAny = (value: string) =>
  pipe(
    O.tryCatch(() => JSON.parse(value)),
    O.chain(O.fromNullable)
  );

export const parseQueryString = (querystring: string) => (parameterName: string) =>
  pipe(qs.parse(querystring)[parameterName] as string, O.fromNullable);

export const parseBoolean = (value: string) => value === 'true';
